// components/downloadButton/DownloadButton.js
import React from 'react';
import './DownloadButton.css';

const DownloadButton = ({ messageContent }) => {
  const handleDownload = () => {
    try {
      // Extract JSON array from the content - find everything between first [ and last ]
      const startIndex = messageContent.indexOf('[');
      const endIndex = messageContent.lastIndexOf(']');
      
      if (startIndex === -1 || endIndex === -1 || startIndex >= endIndex) {
        // No valid JSON array found
        console.warn('No valid JSON array found in the content');
        alert('Unable to extract valid data for download');
        return;
      }

      // Extract and parse the JSON array
      const jsonString = messageContent.substring(startIndex, endIndex + 1);
      const testCases = JSON.parse(jsonString);

      // Process the test cases and flatten them
      const flattenedData = [];
      
      testCases.forEach(testCase => {
        // For each test step in the test case, create a row
        if (Array.isArray(testCase['Test Steps'])) {
          testCase['Test Steps'].forEach(step => {
            flattenedData.push({
              'Test Number(Id)': testCase['Test Number'],
              'Test Case Name': testCase['Test Case Name'],
              'Test Description': testCase['Test Description'],
              'Test Category': 'Functional Test', // Default value
              'Test Type': 'Manual', // Default value
              'Step Name': step.step_name,
              'Step Description': step.description,
              'Expected Results': step.expected_result,
              'Req_Id': step.req_id
            });
          });
        } else {
          // Handle case when there are no test steps
          flattenedData.push({
            'Test Number(Id)': testCase['Test Number'],
            'Test Case Name': testCase['Test Case Name'],
            'Test Description': testCase['Test Description'],
            'Test Category': 'Functional Test',
            'Test Type': 'Manual',
            'Step Name': '',
            'Step Description': '',
            'Expected Results': '',
            'Req_Id': ''
          });
        }
      });

      // Convert to CSV
      const headers = [
        'Test Number(Id)', 
        'Test Case Name', 
        'Test Description', 
        'Test Category', 
        'Test Type', 
        'Step Name', 
        'Step Description', 
        'Expected Results', 
        'Req_Id'
      ];
      
      let csvContent = headers.join(',') + '\n';
      
      flattenedData.forEach(row => {
        const values = headers.map(header => {
          // Escape quotes and handle commas in cell values
          const cellValue = row[header] ? row[header].toString() : '';
          return `"${cellValue.replace(/"/g, '""')}"`;
        });
        csvContent += values.join(',') + '\n';
      });

      // Create and download CSV file
      const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
      const url = URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.setAttribute('href', url);
      link.setAttribute('download', 'test_cases.csv');
      link.style.visibility = 'hidden';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (error) {
      console.error('Error processing data for download:', error);
      alert('Error processing data. Please check the console for details.');
    }
  };

  return (
    <button 
      className="download-button" 
      onClick={handleDownload}
      title="Download as CSV"
    >
      <span className="download-icon">⬇️</span>
      <span className="download-text">CSV</span>
    </button>
  );
};

export default DownloadButton;